import { HTMLAttributes } from 'react';
import { FiChevronLeft, FiChevronRight, FiLoader } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Button, ButtonProps } from '@britishcouncil/react-registration-platform';

import { cn } from '@/core/helpers/cn';
import { getReturnToReviewFrom } from '@/store';
import { useIsReviewMode } from '@/utils';

type Props = HTMLAttributes<HTMLDivElement> & {
  submitButton: Omit<ButtonProps, 'type' | 'disabled'> & { label?: string; isLoading?: boolean };
  backButton: ButtonProps & { label?: string };
};

export const StepButtonsForm = ({
  submitButton: { label: submitButtonLabel, isLoading, ...submitButtonRest },
  backButton: { label: backButtonLabel, ...backButtonRest },
  className,
  ...rest
}: Props) => {
  const { t } = useTranslation('');
  const returnToReviewFrom = useSelector(getReturnToReviewFrom);
  const isReview = useIsReviewMode();
  const buttonTranslationKey = (returnToReviewFrom || isReview) ? 'common.save-and-review' : 'common.next-button';
  const buttonLabel = submitButtonLabel || t(buttonTranslationKey);
  return (
    <div className={cn('flex justify-start gap-6 ', className)} {...rest}>
      <Button type="button" variant="secondary" {...backButtonRest}>
        <FiChevronLeft className="text-[20px] relative top-[-1px] mr-[10px] hidden md:block" /> {backButtonLabel ? backButtonLabel : t('common.back-button')}
      </Button>
      <Button type="submit" disabled={isLoading} className="w-auto" {...submitButtonRest}>
        {buttonLabel}
        {isLoading ? (
          <FiLoader className="text-[20px] relative top-[-2px] ml-[10px] animate-spin-slow inline-block"></FiLoader>
        ) : (
          <FiChevronRight className="text-[20px] relative top-[-1px] ml-[10px] hidden md:block" />
        )}
      </Button>
    </div>
  );
};
